import React, { useState } from 'react'
import { get, isEmpty } from 'lodash'

import { onEnter } from '../../../utilities/accessibility/onEnter'
import AccommodationDetailModal from '../../AccomodationModal/AccommodationDetailModal'
import AccommodationDetailsModal from '../../AccommodationDetails/AccommodationDetailsModal'

const AccommodationItem = ({ image, name, accommodation }) => {
  const displayNewAccommodationModal = !isEmpty(get(accommodation, 'viewExtensions.northstar'))

  const [isOpen, setIsOpen] = useState(false)
  const [windowOffset, setWindowOffset] = useState(0)

  function toggleModal() {
    if (isOpen) {
      document.body.setAttribute('style', '')
      window.scrollTo(0, windowOffset)
    } else {
      setWindowOffset(window.scrollY)
      document.body.setAttribute('style', `overflow: hidden;`)
    }
    setIsOpen(!isOpen)
  }

  const displayItineraryFlag = get(accommodation, 'viewExtensions.itineraryFlag')
  const itineraryFlag = get(accommodation, 'viewExtensions.itineraryText')

  return (
    <>
      <div
        className="accommodations-list__item"
        onClick={toggleModal}
        onKeyDown={(event) => onEnter(event, toggleModal)}
        role="button"
        tabIndex="0"
      >
        {displayItineraryFlag && itineraryFlag && (
          <div className="accommodations-list__item__itinerary-flag">
            {itineraryFlag}
          </div>
        )}
        {image && (
          <img
            alt=""
            className="accommodations-list__item__image"
            src={image}
          />
        )}
        <p
          className="accommodations-list__item__name"
          dangerouslySetInnerHTML={{ __html: name }}
        />
      </div>
      {displayNewAccommodationModal ? (
        <AccommodationDetailsModal
          accommodation={accommodation}
          toggleModal={toggleModal}
          isOpen={isOpen}
        />
      ) : (
        <AccommodationDetailModal
          accommodation={accommodation}
          toggleModal={toggleModal}
          isOpen={isOpen}
        />
      )}
    </>
  )
}

export default AccommodationItem
